import { loginApi, registerApi } from "@/api/auth"; // ✅ 加 registerApi

const TOKEN_KEY = "player_token";
const USER_KEY = "player_user";

function readToken() {
    return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY) || "";
}

function readUser() {
    const raw =
        sessionStorage.getItem(USER_KEY) ||
        localStorage.getItem(USER_KEY) ||
        "null";
    try {
        return JSON.parse(raw);
    } catch (e) {
        return null;
    }
}

function clearAuthStorage() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
}

const state = {
    token: readToken(),
    user: readUser()
};

const getters = {
    isAuthed: (s) => !!s.token,
    user: (s) => s.user
};

const mutations = {
    SET_AUTH(state, { token, user, remember }) {
        state.token = token;
        state.user = user;

        clearAuthStorage();

        const storage = remember === false ? sessionStorage : localStorage;
        storage.setItem(TOKEN_KEY, token);
        storage.setItem(USER_KEY, JSON.stringify(user));
    },

    LOGOUT(state) {
        state.token = "";
        state.user = null;
        clearAuthStorage();
    },

    SYNC_FROM_STORAGE(state) {
        state.token = readToken();
        state.user = readUser();
    }
};

const actions = {
    async login({ commit }, { username, password, remember }) {
        const res = await loginApi(username, password);
        const data = res.data || {};

        const token = data.token;
        const user = { userId: data.userId, username: data.username };

        if (!token) throw new Error("login response missing token");

        commit("SET_AUTH", { token, user, remember });
        return data;
    },

    // ✅ 新增：注册
    async register({ commit }, { username, password, confirmPassword, currency = "KHR", remember }) {
        const res = await registerApi({ username, password, confirmPassword, currency });
        const data = res.data || {};

        const token = data.token;
        const user = { userId: data.userId, username: data.username };

        if (!token) throw new Error("register response missing token");

        // 注册成功默认写 localStorage（除非你也传 remember=false）
        commit("SET_AUTH", { token, user, remember });
        return data;
    },

    logout({ commit }) {
        commit("LOGOUT");
    }
};

export default { namespaced: true, state, getters, mutations, actions };
